import React from 'react';
import { StarIcon } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'María Elena',
    age: 47,
    location: 'Buenos Aires, Argentina',
    text: 'Después de semanas sintiéndome agotada, esta guía me ayudó a entender qué le pasaba a mi cuerpo. Los cambios fueron graduales pero reales.'
  }, {
    name: 'Carolina',
    age: 42,
    location: 'Bogotá, Colombia',
    text: 'No podía creer que algo tan simple como cambiar ciertos hábitos pudiera hacer tanta diferencia. Me siento con más energía que hace años.'
  }, {
    name: 'Lucía',
    age: 51,
    location: 'Madrid, España',
    text: 'Llevaba meses con insomnio y cambios de humor terribles. Esta guía me dio herramientas prácticas que realmente funcionaron.'
  }, {
    name: 'Fernanda',
    age: 39,
    location: 'Ciudad de México, México',
    text: 'El plan alimenticio fue un cambio total. La inflamación bajó notablemente y volví a sentirme yo misma.'
  }, {
    name: 'Valentina',
    age: 45,
    location: 'Santiago, Chile',
    text: 'Simple, clara y efectiva. Ojalá hubiera encontrado esta información antes. Se la recomiendo a todas mis amigas.'
  }];
  return <section className="py-16 px-4 bg-brand-cream" data-id="element-176">
      <div className="max-w-5xl mx-auto" data-id="element-177">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-178">
          Cada vez más mujeres están descubriendo que entender su sistema
          hormonal puede cambiar completamente cómo se sienten.
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-179">
          {testimonials.map((t, index) => <div key={index} className={`bg-white p-6 rounded-2xl shadow-md border border-brand-green/5 ${index === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-180">
              <div className="flex text-brand-gold mb-4" data-id="element-181">
                {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="w-4 h-4 fill-current" data-id="element-182" />)}
              </div>
              <p className="text-gray-700 italic mb-6" data-id="element-183">"{t.text}"</p>
              <div className="mt-auto" data-id="element-184">
                <p className="font-bold text-brand-green" data-id="element-185">
                  {t.name}, {t.age} años
                </p>
                <p className="text-sm text-gray-500" data-id="element-186">{t.location}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}